import MenuIcon from '@mui/icons-material/Menu'
import { Box, DrawerProps, IconButton, Drawer as MuiDrawer, styled, Toolbar } from '@mui/material'
import { staticPath } from '~/lib/$path'
import { drawerWidth } from '~/lib/theme'
import { AppDrawerContent } from './AppDrawerContent'

type Props = {
  open: boolean
  onClose?: () => void
  isMobileAndRender: boolean
}

export const AppDrawer = ({ open, onClose, isMobileAndRender }: Props) => (
  <>
    <DrawerInternal
      open={isMobileAndRender ? open : false}
      onClose={onClose}
      variant="temporary"
      sx={(theme) => ({ [theme.breakpoints.up('md')]: { display: 'none' } })}
    />
    <DrawerInternal
      open={open}
      onClose={onClose}
      variant="persistent"
      sx={(theme) => ({ [theme.breakpoints.down('md')]: { display: 'none' } })}
    />
  </>
)

const DrawerInternal = (props: Partial<DrawerProps>) => (
  <Drawer
    {...props}
    sx={[
      {
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      },
      ...[props.sx ?? false].flat(),
    ]}
    anchor="left"
  >
    <Toolbar sx={{ gap: 1, justifyContent: 'center' }}>
      <img
        src={staticPath.toridori_marketing_logo_1_png}
        alt="トリドリマーケティング"
        style={{ height: '24px', objectFit: 'contain' }}
      />
      <IconButton onClick={props.onClose as () => void}>
        <MenuIcon />
      </IconButton>
    </Toolbar>

    <AppDrawerContent />

    {/* safe area keeper */}
    <Box sx={{ height: 'env(safe-area-inset-bottom, 0)', flexShrink: 0 }} />
  </Drawer>
)

const Drawer = styled(MuiDrawer)(({ theme, open, variant }) => ({
  // persistentなDrawerは、open=falseのときに余白が残るので、marginで相殺する
  ...(variant === 'persistent' && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
}))
